import { CommonButton } from 'components/common/Forms/Button';
import CheckboxInput from 'components/common/Forms/CheckboxInput';
import { DatePickerInput } from 'components/common/Forms/DatePickerInput';
import React, { ReactElement } from 'react';
import { FaPrint } from 'react-icons/fa';
import {
  ApptHeaderLeft,
  ApptHeaderRight,
  ApptHeaderWrapper,
} from './AppointmentsHeader.styled';
import { AppointmentsHeaderTooltip } from './AppointmentsHeaderTooltip';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import { CardDividerHeaderSection } from '../../../../components/common';
import { APPOINTMENT_HOVER_INDEX } from '../AppointmentsTimes.styled';
import { OverflowButton } from '../../../../components/views-components/staff/appointments/overflow/OverflowButton';
import {
  DatePickerInputOnChange,
  DatePickerInputValue,
} from '../../../../components/common/Forms/DatePickerInput.hooks';

interface Props {
  selectedDate: DatePickerInputValue;
  setSelectedDate: DatePickerInputOnChange;
  isUpdate: boolean;
  setIsUpdate: (value: boolean) => void;
  onDnaMiaClicked: () => void;
  onRefreshClicked: () => void;
  onOverflowClicked?: () => void;
  showPrintButton?: boolean;
}

const AppointmentsHeader = ({
  selectedDate,
  setSelectedDate,
  isUpdate,
  setIsUpdate,
  onDnaMiaClicked,
  onRefreshClicked,
  onOverflowClicked,
  showPrintButton = false,
}: Props): ReactElement => {
  const { t } = useCommonTranslation();

  return (
    <CardDividerHeaderSection>
      <ApptHeaderWrapper>
        <ApptHeaderLeft>
          <DatePickerInput
            sizing={'MIN_CONTENT'}
            noSpaceForHelperText
            name="Appt-DatePicker"
            onChange={(val) => setSelectedDate(val)}
            value={selectedDate}
            popperZIndex={APPOINTMENT_HOVER_INDEX + 1}
          />
          <CheckboxInput
            label={t('update')}
            name="Appt-Updated-Now"
            checked={isUpdate}
            onCheckedStateChange={(value) => setIsUpdate(value)}
          />
          <CommonButton variant="primary" onClick={onDnaMiaClicked}>
            {t('dna-mia')}
          </CommonButton>
          <CommonButton variant="secondary" onClick={onRefreshClicked}>
            {t('refresh')}
          </CommonButton>
        </ApptHeaderLeft>
        {(showPrintButton || onOverflowClicked) && (
          <ApptHeaderRight>
            {showPrintButton && (
              <CommonButton
                variant="secondary"
                onClick={() => {
                  // Webkit deadlocks when window.print() runs synchronously
                  setTimeout(() => window.print(), 0);
                }}
              >
                <FaPrint style={{ marginRight: 'var(--s1)' }} />
                {t('print-list')}
              </CommonButton>
            )}
            {onOverflowClicked && (
              <OverflowButton onOverflowClicked={onOverflowClicked} />
            )}
          </ApptHeaderRight>
        )}
        <AppointmentsHeaderTooltip />
      </ApptHeaderWrapper>
    </CardDividerHeaderSection>
  );
};
export default AppointmentsHeader;
